import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardBody, CardFooter, CardTitle, Gallery, PageSection, } from "@patternfly/react-core";
import { map } from "lodash";
import { useEffect } from "react";
import { fetchProducts } from "../redux/productsReducer";
import { useAppDispatch, useAppSelector } from "../redux/reduxHook";
import { Link } from "react-router-dom";
export function Products() {
    var dispatch = useAppDispatch();
    var products = useAppSelector(function (state) { return state.products.products; }).data;
    console.log("product", products);
    useEffect(function () {
        dispatch(fetchProducts());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(PageSection, { isFilled: true, children: _jsx(Gallery, { hasGutter: true, "aria-label": "Selectable card container", children: map(products, function (product) { return (_jsxs(Card, { isCompact: true, children: [_jsx(CardTitle, { children: _jsx("img", { src: product.image, alt: product.title, style: { maxWidth: "100px" } }) }), _jsx(CardBody, { children: _jsx(Link, { to: "/products/".concat(product.id), children: product.title }) }), _jsxs(CardFooter, { children: ["\u20B9", product.price] })] }, product.id)); }) }) }));
}
